// API endpoints
export const API_ENDPOINTS = {
    MARKETING_USERS: '/users/role?roleName=MARKETING',
    SUPPLY_CHAIN_USERS: '/users/role?roleName=SUPPLY CHAIN'
};

// Department types
export const DEPARTMENTS = {
    MARKETING: 'MARKETING',
    SUPPLY_CHAIN: 'SUPPLY_CHAIN'
};

// Labels
export const LABELS = {
    REQUEST_SUPPORT: 'Request Implementation Support',
    SELECT_TEAMS: 'Select Support Teams:',
    MARKETING: 'Marketing',
    SUPPLY_CHAIN: 'Supply Chain',
    SELECT_MARKETING_MEMBER: 'Select marketing team member',
    SELECT_SUPPLY_CHAIN_MEMBER: 'Select supply chain team member'
};

// Alert messages
export const ALERT_MESSAGES = {
    SUPPORT_INFO: 'If you request implementation support, you must select at least one member from the Marketing or Supply Chain team.',
    TEAMS_REVIEW: 'Selected teams will review your plan'
};

// UI constants
export const UI_CONSTANTS = {
    LOADING_SIZE: '2em',
    LOADING_THICKNESS: 4,
    FONT_SIZES: {
        LABEL: '0.875rem',
        ALERT: '0.75rem'
    },
    CHECKBOX_PADDING: 0.5,
    INDENT_SPACING: 3
};

// Component IDs
export const COMPONENT_IDS = {
    MARKETING_CHECKBOX: 'marketing-support-checkbox',
    SUPPLY_CHAIN_CHECKBOX: 'supplychain-support-checkbox'
};